'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EventsMap;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _containers = require('../containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EventsMap() {
  return _react2.default.createElement(
    'div',
    { className: 'EventsMap' },
    _react2.default.createElement(
      'div',
      { className: 'map' },
      _react2.default.createElement(_containers.DynamicMapContainer, null)
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EventsMap.js
// module id = 1165
// module chunks = 0